<template>
  <div>
    <div
      ref="wrapper"
      class="rm-Content_Wrapper"
      :class="{
        'rm-Content_Wrapper-hasmore': shouldCropContent,
        'rm-Content_Wrapper-white': use_white_background,
      }"
      :style="shouldCropContent ? `max-height: ${maxHeight}px` : ''"
      v-on="shouldCropContent ? { click: () => toggleShow() } : {}"
    >
      <slot />
    </div>
    <button v-if="hasMoreContent" class="btn btn-sm btn-block rm-Button" @click="toggleShow">
      {{ hideContent ? more_text : less_text }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ReadMore",
  props: {
    max_height: {
      type: Number,
      default: 100,
    },
    more_text: {
      type: String,
      required: true,
    },
    less_text: {
      type: String,
      required: true,
    },
    use_white_background: {
      type: Boolean,
    },
  },
  data() {
    return {
      maxHeight: this.max_height,
      realHeight: undefined,
      hasMoreContent: false,
      hideContent: true,
    };
  },
  computed: {
    shouldCropContent() {
      return this.hideContent && this.hasMoreContent;
    },
  },
  mounted() {
    this.realHeight = this.$refs.wrapper.clientHeight;
    this.hasMoreContent = this.realHeight > this.maxHeight;
  },
  methods: {
    toggleShow(e) {
      this.hideContent = !this.hideContent;
      e.target.blur();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.rm-Button {
  font-weight: $font-weight-bold;
  font-size: $font-size-sm;
  background: none;
  color: $gray-600;
  border: 0;
  padding: $spacer / 4 0;
  padding-top: $spacer;
  transition: color $transition-duration;
  text-align: left;

  &:hover,
  &:focus {
    color: $gray-700;
    box-shadow: none;
  }
}

.rm-Content_Wrapper-hasmore {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: opacity $transition-duration-short;

  &::before {
    content: "";
    height: 50px;
    width: 100%;
    z-index: 10;
    position: absolute;
    bottom: 0;
    left: 0;
    pointer-events: none;
    background: linear-gradient(to bottom, rgba($gray-100, 0) 0%, rgba($gray-100, 1) 100%);
  }
}

.rm-Content_Wrapper-white {
  &::before {
    background: linear-gradient(to bottom, rgba($white, 0) 0%, rgba($white, 1) 100%);
  }
}
</style>
